// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PortalVue from 'portal-vue'
import App from './App'
import router from './router'
import store from './store'
import VueNumeric from 'vue-numeric'
import JsonExcel from 'vue-json-excel'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import BaseLoader from '@/app/shared/components/BaseLoader'
import numeral from './plugin/CustomNumeral'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import lodash from 'lodash'
import Loading from 'vue-loading-overlay'
import '@/utils/Filters'
import makeServer from './app/shared/plugins/Mirage'
import VueCompositionAPI, { provide } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueGtag from 'vue-gtag';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


if (process.env.NODE_ENV === 'mirage') {
  makeServer({ environment: 'development' })
}

// Load Locales ('en' comes loaded by default)
require('moment/locale/es');

// Choose Locale
moment.locale('es');

Vue.use(VueCompositionAPI)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(PortalVue)
Vue.use(VueNumeric)
Vue.use(Viewer)
Vue.use(VueApexCharts)
Vue.use(DateRangePicker)

Vue.component('downloadExcel', JsonExcel)
Vue.component('pulseLoader', PulseLoader)
Vue.component('ExpertoRetailLoader', BaseLoader)
Vue.component('Loading', Loading)
Vue.component('apexchart', VueApexCharts)
Vue.component('DateRangePicker', DateRangePicker)
Vue.use(VueMoment, { moment });

Vue.use(VueGtag, {
  config: {
    id: 'G-FTH8CW3WQB',
    params: {
      send_page_view: false
    }
  }
});

Vue.mixin({
  methods: {
    deepCopy: function (obj) {
      var clone = {}
      for (var i in obj) {
        if (obj[i] != null && typeof (obj[i]) === 'object') {
          clone[i] = this.deepCopy(obj[i])
        } else {
          clone[i] = obj[i]
        }
      }
      return clone
    },
    deepCopyJsonMode: function (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    $_moneyNumeralFormat: value => {
      return numeral(value).format('$ 0.00 a')
    },
    $_moneyNumeralFormatVerbose: value => {
      return numeral(value).format('$ 0,0')
    },
    $_numberNumeralFormat: value => {
      return numeral(value).format('0.00 a')
    },
    $_numberNumeralFormatVerbose: value => {
      return numeral(value).format('0,0')
    },
    $_numberNumeralFormat_2: value => {
      return numeral(value).format('0,0')
    },
    $_percentageNumeralFormat: value => {
      return numeral(value).format('0%')
    },
    $_formatMetricValue (formatType, value) {
      if (formatType === 'PESOS') {
        return this.$_moneyNumeralFormat(value)
      } else if (formatType === 'UNITS') {
        return this.$_numberNumeralFormat(value)
      } else if (formatType === 'PERCENTAGE') {
        return this.$_percentageNumeralFormat(value)
      }
    },
    $_formatMetricValueVerbose (formatType, value) {
      if (formatType === 'PESOS') {
        return this.$_moneyNumeralFormatVerbose(value)
      } else if (formatType === 'UNITS') {
        return this.$_numberNumeralFormatVerbose(value)
      } else if (formatType === 'PERCENTAGE') {
        return this.$_percentageNumeralFormat(value)
      }
    }
  }
})

/* eslint-disable no-new */

Vue.prototype.$eventHub = new Vue()
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  setup() {
    provide('vuex-store', store);
  },
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js